import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles/variables';
export const SwitchButton = ({ classObject, onClick, isOn, disabled }) => {
    const [submitting, setSubmitting] = React.useState(false);
    const onSubmit = () => {
        if (submitting || disabled)
            return;
        setSubmitting(true);
        Promise.resolve(onClick()).finally(() => {
            setSubmitting(false);
        });
    };
    return (React.createElement("div", { className: css(classObject, styles.switchContainer, isOn ? styles.switchOn : styles.switchOff, disabled && styles.switchDisabled), onClick: onSubmit }));
};
const styles = StyleSheet.create({
    switchContainer: {
        position: 'relative',
        width: 26,
        height: 14,
        borderRadius: 7,
        cursor: 'pointer',
        ':before': {
            content: '""',
            position: 'absolute',
            top: -3,
            borderRadius: 80,
            width: 20,
            height: 20,
        },
    },
    switchOn: {
        background: Colors.BlueLighterB,
        ':before': {
            right: -7,
            background: Colors.PrimaryDark,
        },
    },
    switchOff: {
        background: Colors.BackgroundLightGray,
        ':before': {
            left: -7,
            background: Colors.GrayDarkest,
        },
    },
    switchDisabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
});
